import {UpdateManager} from '@fantasmagames/core/src/update/UpdateManager';
import {Timer} from '@fantasmagames/core/src/update/Timer';

export class TimerUtils {
	protected _updateManager: UpdateManager;

	constructor(updateManager: UpdateManager) {
		this._updateManager = updateManager;
	}

	public oneFrameTimer(callback: Function): Timer {
		const timer: Timer = new Timer(callback, 0, true);
		this._updateManager.add(timer);

		return timer;
	}

	public createTimer(callback: Function, delay: number): Timer {
		const timer: Timer = new Timer(callback, delay, true);
		this._updateManager.add(timer);

		return timer;
	}

	public killTimer(timer: Timer): void {
		if (timer) {
			timer.stop();
		}
	}

}



// WEBPACK FOOTER //
// ./@fantasmagames/core/src/update/TimerUtils.ts